import axios from "../../../axios/index.js"
import store from "../../../../store/store.js"

// Token Refresh
let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched(access_token) {
  subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber(callback) {
  subscribers.push(callback)
}

export default {
  init() {

    var token = localStorage.getItem("accessToken");
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    axios.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      // const { config, response: { status } } = error
      const { config, response } = error
      const originalRequest = config

      // if (status === 401) {
      if (response && response.status === 401) {
        this.$router.push("/login");
        // if (!isAlreadyFetchingAccessToken) {
        //   isAlreadyFetchingAccessToken = true
        //   store.dispatch("auth/fetchAccessToken")
        //     .then((access_token) => {
        //       isAlreadyFetchingAccessToken = false
        //       onAccessTokenFetched(access_token)
        //     })
        // }

        // const retryOriginalRequest = new Promise((resolve) => {
        //   addSubscriber(access_token => {
        //     originalRequest.headers.Authorization = 'Bearer ' + access_token
        //     resolve(axios(originalRequest))
        //   })
        // })
        // return retryOriginalRequest
      }
      return Promise.reject(error)
    })
  },
  login(email, pwd) {
    return axios.post("/api/auth/login", {email : email, password : pwd})
  },
  // viewProfile(){
  //   return axios.get("api/viewProfile", {})
  // },
  registerUser(first_name, last_name, email, pwd) {
    return axios.post("/api/auth/signup", {first_name:first_name, last_name:last_name, email: email, password: pwd})
  },
  updateUser(first_name, last_name, email) {
    return axios.post("/api/updateUser", {first_name:first_name, last_name:last_name, email: email})
  }, 
  updateUserPassword(old_password, new_password, confirm_new_password) {
    return axios.post("/api/updateUserPassword", {old_password:old_password, new_password:new_password, confirm_new_password: confirm_new_password})
  },
  viewProfile() {
    return axios.post("/api/viewProfile")
  },
  refreshToken() {
    return axios.post("/api/auth/refresh-token", {accessToken: localStorage.getItem("accessToKen")})
  }
}
